import React from 'react';

import PropertyManagementTable from './property_management_table';
import ScheduleTable from './schedule_table';

import './styles.scss';

export function RoyaltySettings() {
  return (
    <div className="royalty-settings">
      <ScheduleTable />
      <PropertyManagementTable />
    </div>
  );
}

export default RoyaltySettings;
